import * as React from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import styles from './Nav.scss';
import NavMap, { NavItemType } from '~/Components/Nav/NavMap';
import { useDispatch } from 'react-redux';
import { resetSearch } from '~/Actions/ActionCategory';
import { playButtonClickSound } from '~/helpers/audioApi';
import dwhExport from '~/helpers/dwhExport';
import { DWH_EVENTS, Places } from '~/helpers/consts';

const Nav = () => {
    const dispatch = useDispatch();
    const classes = classNames(styles.nav, styles.blurable);
    const onClick = (item: NavItemType) => {
        dwhExport.send(DWH_EVENTS.PAGE_OPEN, { name: item.name, from: Places.MENU });
        dispatch(resetSearch());
        playButtonClickSound();
    };

    return (
        <nav className={classes}>
            {NavMap.map((navItem, index) => {
                return (
                    <NavLink 
                        key={`nav_${navItem.name}_${index}`} 
                        to={navItem.link} 
                        className={styles.link} 
                        activeClassName={styles.linkCurrent} 
                        onClick={() => {
                            onClick(navItem);
                        }}
                    >
                        {navItem.title}
                    </NavLink>
                );
            })}
        </nav>
    );
};

export default React.memo(Nav);
